import CompletenssChart from "../../../components/charts/completenessChart/CompletenessChart";
import "../../../styles/stores/stockManagement/checkStocOthers.css";
import { AiOutlineClose } from "react-icons/ai";
import { useEffect, useLayoutEffect, useState, useMemo } from "react";
import { createProductUrl, getProductHistoryUrl } from "../../../api/endpoints";
import { useSelector } from "react-redux";
import { MdFmdBad, MdGppGood, MdKeyboardArrowDown } from "react-icons/md";
import { BsFillCalendarDateFill } from "react-icons/bs";
import { syncOfflineQueue } from "../../../tools/synOfflineQueue";
import Spinner from "../../../components/uxCollections/Loaders";

import Pagination from "../../../components/pagination/PaginationTab";
import DropdownFilter from "../../../components/filter/yearMonthFIlter";
import ActivityLogSkeleton from "../../../components/uxCollections/skeletonLoader/productActivity/ProductHistorySkeletion";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";

import { createPortal } from "react-dom";
import * as XLSX from "xlsx";
import "./Producthistory.css";

import {
  Download,
  Check,
  SlidersHorizontal,
  Calendar,
  PlusCircle,
  Pencil,
  Percent,
  ShoppingCart,
  Undo2,
  Trash2,
  PackagePlus,
  AlertTriangle,
  ArrowRightLeft,
  X,
  Circle,
  Search,
  ClipboardList,
  RotateCcw,
  CheckCircle2,
  ArrowUpCircle,
  ArrowDownCircle,
  ChevronRight,
} from "lucide-react";

/* const CheckStock = ({ openModal, closeModal }) => {
  const [showSummary, setShowSummary] = useState(false);
  const [products, setProducts] = useState([]);
  const [productQtyInStore, setProductQtyInStore] = useState([]); //[{productID:123, qty:12}
  const [isLoading, setIsLoading] = useState(true); //
  const [allInputFilled, setAllInputFilled] = useState(false); //
  const [completenessPercentage, setCompletenessPercentage] = useState(null); //
  const [loadingProgress, setLoadingProgress] = useState(null); //
  const [productSummary, setProductSummary] = useState(null);
  const [showProductHistory, setShowProductHistory] = useState(false);
  const [historyToShow, setHistoryToShow] = useState(null);
  const [productToShowHistory, setProductToShowHistory] = useState(null);
  const { store } = useSelector((state) => state.store);
  const { count, queue } = useSelector((state) => state.offlineQueue);

  useLayoutEffect(() => {
    checkOfflineQueueAndSync();
  }, []);
  const checkOfflineQueueAndSync = async () => {
    if (count) {
      try {
      
        setLoadingProgress("Synchronizing transactions");
        await syncOfflineQueue();

        fetchProducts();
      } catch (error) {
        console.log(error);
      }
    } else {
      setLoadingProgress("Fetching store products");
      fetchProducts();
    }
  };

  useLayoutEffect(() => {
    console.log(productQtyInStore);
    let allFilled = productQtyInStore.every((prod) => prod.qty !== null && prod.qty !== "");
    setAllInputFilled(allFilled);
    !allFilled && setShowSummary(false);
    console.log(allFilled);
  }, [productQtyInStore]);

  const fetchProducts = async () => {
    try {
      let response = await fetch(createProductUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.ok) {
        let storeProductCollection = await response.json();
        console.log(storeProductCollection);
        setProducts(storeProductCollection.products);
        setProductQtyInStore(
          storeProductCollection.products.map((product) => ({
            productID: product._id,
            qty: null,
          }))
        );
        setIsLoading(false);
        setLoadingProgress(false);
      } else if (response.status === 404) {
        setProducts([]);
        setProductQtyInStore([]);
        setIsLoading(false);
        setLoadingProgress(false);
      } else if (response.status === 400) {
        uiAlert("something went wrong", "error");
      }
    } catch (error) {
      console.log();
    }
  };

  const checkStock = async () => {
    let numberOfProductsWhichAreExcess = 0;
    let numberOfIncompleteProducts = 0; 
    let numberOfCompleteProducts = 0;

    let productSummary = [];

    products.forEach((product) => {
      let productQty = productQtyInStore.find((prod) => prod.productID === product._id);
      if (productQty) {
        let diff = productQty.qty - product.quantity;
        if (diff === 0) {
          numberOfCompleteProducts++;
          productSummary.push({ product, status: `${product.name} is complete` });
        } else if (diff > 0) {
        
          numberOfProductsWhichAreExcess++;
          productSummary.push({ product, status: `${product.name} has ${diff} items more in store` });
        } else {
         
          numberOfIncompleteProducts++;
          productSummary.push({ product, status: `${product.name} is missing ${-diff} items in store` });
        }
      }
    });

   
    let totalProducts = numberOfCompleteProducts + numberOfIncompleteProducts + numberOfProductsWhichAreExcess;
    let percentage = (numberOfCompleteProducts / totalProducts) * 100;
    console.log(percentage, numberOfCompleteProducts, totalProducts);
    setCompletenessPercentage(percentage);
    setProductSummary(productSummary);
    setShowSummary(true);
  };

  return (
    <>
    

      <div className={`checkStockWrapper ${openModal}`}>
        {isLoading ? (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",
              position: "relative",
              flexDirection: "column",
            }}
          >
            <Spinner position={""} transparent={false} backgroundColor={"white"} />

            <p style={{ marginTop: "40px", fontSize: "0.87rem", fontWeight: "600" }}> {loadingProgress && loadingProgress} </p>
          </div>
        ) : (
          <div>
            <h1 className='titleCheckSales'> Stock Checking window</h1>
            <div onClick={() => closeModal(false)} className='closeStChP'>
              <AiOutlineClose />
            </div>
            <p style={{ marginBottom: "30px", display: "flex", alignItems: "center" }}>
              {" "}
              <span style={{ display: "flex", alignItems: "center" }}>
                <BsFillCalendarDateFill style={{ fontSize: "16px", marginRight: "10px" }} />
              </span>{" "}
              It is recommended to check your stock weekly 
            </p>
            <div className='wrapperDivCheckstock33'>
              <div className='quantityInput22'>
                {products.map((product, index) => (
                  <EachStockToCheck key={index} product={product} updateProdQty={setProductQtyInStore} />
                ))}
              </div>
              {showSummary ? (
                <div className='summaryStock223'>
                  <div className='CompletenessChartDiv'>
                    <h4 className='summaryTitle4'>Completenss</h4>
                    {showSummary && (
                      <CompletenssChart
                        value={parseInt(completenessPercentage)}
                        color={completenessPercentage > 80 ? "#007991" : completenessPercentage < 80 && completenessPercentage > 50 ? "gold" : "red"}
                      />
                    )}
                  </div>
                  <div className='summaryAnalysis23'>
                    <h4 className='summaryTitle4'>Summary</h4>
                    {productSummary.map((prod, index) => (
                      <div key={index} className='eachProductSUmmaryDIv'>
                        <div>
                          {prod.status.includes("complete") ? <MdGppGood style={{ color: "green" }} /> : <MdFmdBad style={{ color: "red" }} />}
                          <span className='eachSUmPTitle'>{prod.status}</span>
                        </div>
                        <button
                          onClick={() => {
                            setProductToShowHistory(prod.product);
                            setShowProductHistory(true);
                          }}
                        >
                          View history
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className='noSummaryDiv'>
                  <div>
                    {" "}
                    <img src='https://res.cloudinary.com/ebuka1122/image/upload/v1712951361/Ihub-text-images/NoPath_jqqz1c.png' />
                  </div>
                  <div className='bottomFixedBtn'>
                    {allInputFilled ? (
                      <button onClick={checkStock}>Check</button>
                    ) : (
                      <button
                        style={{
                          opacity: 0.5,
                          cursor: "not-allowed",
                        }}
                      >
                        Check
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {showProductHistory && (
        <ProductHistory
          closeModal={setShowProductHistory}
          storeID={store._id}
          product={productToShowHistory}
          setProductToShowHistory={setProductToShowHistory}
        />
      )}
    </>
  );
};

export default CheckStock;

const EachStockToCheck = ({ product, updateProdQty }) => {
  let forbiddenKeys = ["+", "-", "e", "E"];

  const [quantity, setQuantity] = useState(null);

  useLayoutEffect(() => {
    updateProdQty((prev) => {
      let newQty = prev.map((prod) => {
        if (prod.productID === product._id) {
          return { ...prod, qty: quantity };
        } else {
          return prod;
        }
      });

      return newQty;
    });
  }, [quantity]);
  return (
    <>
      <div className='eachStockToCheck22'>
        <p>{product.name}</p>
        <div className='enterQuantityDiv'>
          <p>Enter quantity in store</p>
          <input
            value={quantity}
            type='number'
            onChange={(e) => setQuantity(e.target.value)}
            onKeyDown={(e) => forbiddenKeys.includes(e.key) && e.preventDefault()}
          />
        </div>
      </div>
    </>
  );
}; */

/* export const ProductHistory = ({
  closeModal,
  storeID,
  product,
  setProductToShowHistory = () => {
    return null;
  },
}) => {
  const [monthInView, setMonthInView] = useState(months[new Date().getMonth()]);
  const [yearInView, setYearInView] = useState(new Date().getFullYear());
  const [showAllTime, setShowAllTime] = useState(false);
  const [showAllTimeUI, setShowAllTimeUI] = useState(false);
  // pagination state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  // data + loading/error
  const [history, setHistory] = useState([]);
  const [historyCopy, setHistoryCopy] = useState([]); // to keep a copy of the fetched data
  const [rawHistoryData, setRawHistoryData] = useState([]); // to keep the raw history data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // filter
  const [filter, setFilter] = useState("All");
  const [quantityInFocus, setQuantityInFocus] = useState(0);
  const [displayText, setDisplayText] = useState(
    `${monthInView} ${yearInView}` // Initial display text based on current month and year
  );
  const { count, queue } = useSelector((state) => state.offlineQueue);

  useLayoutEffect(() => {
    checkOfflineQueueAndSync();
  }, []);

  useEffect(() => {
    //  setFilter("All"); // Reset filter when product changes
    if (showAllTime) {
      fetchProductHistory();
      setFilter("All"); // Reset filter to "All" when showing all time history
    }
    setShowAllTime(false); // Reset showAllTime when product changes
    setDisplayText("All Time History"); // Reset display text when product changes
  }, [showAllTime, page, limit]);

  useEffect(() => {
    setShowAllTime(false);
    setFilter("All"); // Reset filter when year or month changes
    setDisplayText(`${monthInView} ${yearInView}`); // Update display text when year or month changes
  }, [yearInView, monthInView]);

  useEffect(() => {
    if (!showAllTime) {
      fetchProductHistory();
    }
  }, [storeID, product, yearInView, monthInView]);

  useEffect(() => {
    console.log("History data updated:", historyCopy);

    // Filter the history data based on the selected filter
    if (filter === "All") {
      let historyCopy = groupHistoryDataByDate(rawHistoryData); // Group the raw data by date
      setHistory(historyCopy); // Show all history
      return;
    }
    // If a specific filter is selected, filter the history data

    const filteredHistory = rawHistoryData?.filter((entry) => entry.historyType === filter);
    // calculate the quantity if history is not discountApplied or modified
    let quantityInFocus = filteredHistory.reduce((acc, entry) => {
      if (entry.historyType !== "discountApplied" && entry.historyType !== "modified") {
        return acc + entry.quantityInFocus;
      }
      return acc;
    }, 0);

    setQuantityInFocus(quantityInFocus); // Update the quantity in focus state

    const groupedFilteredHistory = groupHistoryDataByDate(filteredHistory); // Group the filtered data by date
    setHistory(groupedFilteredHistory); // Update the history state with the filtered and grouped data
  }, [filter]);

  // build the query string
  function buildQuery() {
    const params = new URLSearchParams();
    if (showAllTime) params.set("allTime", "true");
    if (!showAllTime && yearInView) params.set("year", yearInView);
    if (!showAllTime && monthInView) params.set("month", months.indexOf(monthInView)); // months are 0-indexed in JS
    if (showAllTime) {
      params.set("page", page);
      params.set("limit", limit);
    }
    return params.toString();
  }

  const fetchProductHistory = async () => {
    console.log(yearInView, monthInView, showAllTime, page, limit, " fetching product history");

    setLoading(true);
    setError(null);
    const query = buildQuery();
    console.log(`Fetching product history with query: ${getProductHistoryUrl}${storeID}/${product._id}/?${query}`);

    try {
      let response = await fetch(`${getProductHistoryUrl}${storeID}/${product._id}/?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const { data, pagination } = await response.json();
      console.log("Fetched product history:", data, pagination);
      setRawHistoryData(data); // Store the raw history data
      let groupData = groupHistoryDataByDate(data); // Group the history data by date
      console.log("Grouped product history:", groupData);
      setHistory(groupData); // Set the grouped data to state
      setHistoryCopy(groupData); // Assuming you want to keep a copy of the fetched data
      if (pagination) {
        setTotalPages(pagination?.totalPages || 1); // default to 1 if no pagination data
        setPage(pagination?.page);
        setLimit(pagination.limit);
      }
    } catch (error) {
      console.error("Error fetching product history:", error);
      setError(`Failed to fetch product history: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const checkOfflineQueueAndSync = async () => {
    if (count) {
      try {
        
        await syncOfflineQueue();
      } catch (error) {
        setError(`Failed to synchronize offline queue: ${error.message}`);
        console.log(error);
      }
    }
  };

  return (
    <>
      <div
        className='productHistoryWrapper'
        onClick={() => {
          closeModal(false);
          setProductToShowHistory(null);
        }}
      >
        <div className='productHistoryContent' onClick={(e) => e.stopPropagation()}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
            <h3 className='productHistoryTitle'>
              {" "}
              Showing product history for {product.name} ({displayText}){" "}
            </h3>
            <div className='closeHistoryIcon' onClick={() => closeModal(false)}>
              <AiOutlineClose size={24} color='rgb(166, 11, 11)' />
            </div>
          </div>
          <div className='pHistDeta9488w'>
            {loading ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
               
                <ActivityLogSkeleton />
              </div>
            ) : (
              <div>
                <div style={{ marginBottom: "16px" }}>
                  <div className='DivFilta38'>
                    <div onClick={() => setShowAllTime(true)} className='shoAlt3746'>
                      {calenderIcon}
                      {showAllTime ? "All time history" : "Show all time"}
                    </div>
                    <DropdownFilter onYearChange={setYearInView} onMonthChange={setMonthInView} defaultYear={yearInView} defaultMonth={monthInView} />
                  </div>
                </div>
                {Object.keys(history).length > 0 ? (
                  Object.entries(history).map(([dateLabel, entries]) => (
                    <div key={dateLabel} className='history-group'>
                      <h5>{dateLabel}</h5>
                      {entries
                        .slice()
                        .reverse()
                        .map((entry) => (
                          <EachProductHistory key={entry._id} productHistory={entry} />
                        ))}
                    </div>
                  ))
                ) : (
                  <div className='noHistoryFound33'>
                    <img src='https://res.cloudinary.com/ebuka1122/image/upload/v1750534402/Ihub/noHistoryFound_numkw3.webp' />
                  </div>
                )}
              </div>
            )}
            <div className='histCon544'>
              <h4>Select Event to Filter</h4>
              <div className='histFilterDiv'>
                <span onClick={() => setFilter("All")} className={"eachHistFilter" + (filter === "All" ? " selectedHistFilter" : "")}>
                  All
                </span>
                {["created", "modified", "discountApplied", "sold", "returned", "deleted", "restocked", "damageReported", "moved"].map((action, index) => {
                  return (
                    <span onClick={() => setFilter(action)} key={index} className={"eachHistFilter" + (filter === action ? " selectedHistFilter" : "")}>
                      {action.charAt(0).toUpperCase() + action.slice(1).replace(/([A-Z])/g, " $1") }
                    </span>
                  );
                })}
              </div>
              {filter !== "All" && filter !== "discountApplied" && filter !== "modified" && (
                <div>
                  <h4>Quantity</h4>
                  <div className='tQuantHi73'> {quantityInFocus} </div>
                </div>
              )}
            </div>
          </div>
          {displayText === "All Time History" && (
            <Pagination page={page} totalPages={totalPages} onPageChange={setPage} limit={limit} onLimitChange={setLimit} />
          )}
        </div>
      </div>
    </>
  );
}; */

/* const EachProductHistory = ({ productHistory }) => {
  const elementColors = {
    created: "#b7e0b8",
    modified: "rgb(240 243 255)",
    deleted: "rgb(255 232 230)",
    sold: "rgb(237, 252, 240)",
    returned: "rgb(240 240 240)",
    discountApplied: "rgb(246 242 125)",
   
    restocked: "rgb(236 251 250)",
    damageReported: "rgb(255 226 218)",
    moved: "rgb(239 246 250)",
  };
  let elementColor;
  let icon;

  switch (productHistory.historyType) {
    case "created":
      icon = productCreation;
      elementColor = elementColors.created;
      break;
    case "modified":
      icon = productModified;
      elementColor = elementColors.modified;
      break;
    case "deleted":
      icon = productDeleted;
      elementColor = elementColors.deleted;
      break;
    case "sold":
      icon = productSold;
      elementColor = elementColors.sold;
      break;
    case "returned":
      icon = productReturned;
      elementColor = elementColors.returned;
      break;
    case "discountApplied":
      icon = discountApplied;
      elementColor = elementColors.discountApplied;
      break;
    case "restocked":
      icon = productRestock;
      elementColor = elementColors.restocked;
      break;
    case "damageReported":
      icon = productDamaged;
      elementColor = elementColors.damageReported;
      break;
    default:
      icon = productMoved;
      elementColor = elementColors.moved;
  }
  // Helper to convert camelCase to "Title case"
  function humanizeType(type) {
    // Insert spaces before capitals, trim
    const spaced = type.replace(/([A-Z])/g, " $1").trim();
    // Lowercase the entire string, then uppercase only the first character
    const lower = spaced.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }

  return (
    <>
      <div className='eachHistMi37453'>
        <div className='IconImageD88'>
          <div
            style={{
              backgroundColor: elementColor,
            }}
            className='histIcon33'
          >
            {icon}
          </div>
          <div>
            <p className='histActi47'>{productHistory.historyText}</p>
            <p>
              {productHistory.historyType === "damageReported" || productHistory.historyType === "discountApplied"
                ? humanizeType(productHistory.historyType)
                : productHistory.historyType.charAt(0).toUpperCase() + productHistory.historyType.slice(1)}
            </p>
          </div>
        </div>
        <div className='histQCoun66'>{productHistory.quantityInFocus.toLocaleString()}</div>
      </div>
    </>
  );
};

const groupHistoryDataByDate = (historyData) => {
  // Helper dates for today and yesterday
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Group by date label (Today, Yesterday, or formatted date)
  const historyDataGroups = historyData.reduce((acc, entry) => {
    const dateObj = new Date(entry.historyDate);
    const entryDate = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());

    let dateLabel;
    if (entryDate.getTime() === today.getTime()) {
      dateLabel = "Today";
    } else if (entryDate.getTime() === yesterday.getTime()) {
      dateLabel = "Yesterday";
    } else {
      dateLabel = dateObj.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    if (!acc[dateLabel]) acc[dateLabel] = [];
    acc[dateLabel].push(entry);
    return acc;
  }, {});

  return historyDataGroups;
}; */

const STATUS_META = {
  complete: { label: "Complete", color: "#1f9d55", tint: "#edfcf0", icon: (s) => <CheckCircle2 size={s} /> },
  excess: { label: "Excess", color: "#a68b00", tint: "#fbf7dc", icon: (s) => <ArrowUpCircle size={s} /> },
  short: { label: "Short", color: "#c23a3a", tint: "#ffe8e6", icon: (s) => <ArrowDownCircle size={s} /> },
  pending: { label: "Not counted", color: "#8a8f98", tint: "#f2f2f0", icon: (s) => <Circle size={s} /> },
};

const CheckStock = ({ closeModal }) => {
  const [showSummary, setShowSummary] = useState(false);
  const [products, setProducts] = useState([]);
  const [productQtyInStore, setProductQtyInStore] = useState([]); // [{ productID, qty }]
  const [isLoading, setIsLoading] = useState(true);
  const [canRunCheck, setCanRunCheck] = useState(false);
  const [completenessPercentage, setCompletenessPercentage] = useState(null);
  const [loadingProgress, setLoadingProgress] = useState(null);
  const [productSummary, setProductSummary] = useState(null);
  const [showProductHistory, setShowProductHistory] = useState(false);
  const [productToShowHistory, setProductToShowHistory] = useState(null);
  const [search, setSearch] = useState("");
  const [reportFilter, setReportFilter] = useState("all");
  const { store } = useSelector((state) => state.store);
  const { count } = useSelector((state) => state.offlineQueue);

  useLayoutEffect(() => {
    checkOfflineQueueAndSync();
  }, []);

  const checkOfflineQueueAndSync = async () => {
    if (count) {
      try {
        setLoadingProgress("Synchronizing transactions");
        await syncOfflineQueue();
        fetchProducts();
      } catch (error) {
        console.log(error);
      }
    } else {
      setLoadingProgress("Fetching store products");
      fetchProducts();
    }
  };

  useLayoutEffect(() => {
    let anyFilled = productQtyInStore.some((prod) => prod.qty !== null && prod.qty !== "");
    setCanRunCheck(anyFilled);
    !anyFilled && setShowSummary(false);
  }, [productQtyInStore]);

  const fetchProducts = async () => {
    try {
      let response = await fetch(createProductUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.ok) {
        let storeProductCollection = await response.json();
        setProducts(storeProductCollection.products);
        setProductQtyInStore(
          storeProductCollection.products.map((product) => ({
            productID: product._id,
            qty: null,
          }))
        );
        setIsLoading(false);
        setLoadingProgress(false);
      } else if (response.status === 404) {
        setProducts([]);
        setProductQtyInStore([]);
        setIsLoading(false);
        setLoadingProgress(false);
      } else if (response.status === 400) {
        uiAlert("something went wrong", "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleQtyChange = (productID, value) => {
    if (value !== "" && !/^\d*$/.test(value)) return;
    setProductQtyInStore((prev) => prev.map((p) => (p.productID === productID ? { ...p, qty: value } : p)));
  };

  const checkStock = () => {
    let numberOfProductsWhichAreExcess = 0;
    let numberOfIncompleteProducts = 0;
    let numberOfCompleteProducts = 0;
    let numberOfPendingProducts = 0;
    let summary = [];

    products.forEach((product) => {
      let productQty = productQtyInStore.find((prod) => prod.productID === product._id);
      let hasCount = productQty && productQty.qty !== null && productQty.qty !== "";

      if (!hasCount) {
        numberOfPendingProducts++;
        summary.push({ product, counted: null, expected: product.quantity, diff: null, status: "pending" });
        return;
      }

      let counted = Number(productQty.qty);
      let diff = counted - product.quantity;
      let status = diff === 0 ? "complete" : diff > 0 ? "excess" : "short";

      if (status === "complete") numberOfCompleteProducts++;
      else if (status === "excess") numberOfProductsWhichAreExcess++;
      else numberOfIncompleteProducts++;

      summary.push({ product, counted, expected: product.quantity, diff, status });
    });

    let countedProducts = numberOfCompleteProducts + numberOfIncompleteProducts + numberOfProductsWhichAreExcess;
    let percentage = countedProducts > 0 ? (numberOfCompleteProducts / countedProducts) * 100 : 0;

    setCompletenessPercentage(percentage);
    setProductSummary(summary);
    setShowSummary(true);
  };

  const visibleSummary = useMemo(() => {
    if (!productSummary) return [];
    let list = productSummary;
    if (search.trim()) {
      const q = search.trim().toLowerCase();
      list = list.filter((s) => s.product.name?.toLowerCase().includes(q));
    }
    if (reportFilter !== "all") {
      list = list.filter((s) => s.status === reportFilter);
    }
    return list;
  }, [productSummary, search, reportFilter]);

  const visibleProducts = useMemo(() => {
    if (!search.trim()) return products;
    const q = search.trim().toLowerCase();
    return products.filter((p) => p.name?.toLowerCase().includes(q));
  }, [products, search]);

  const gaugeColor = completenessPercentage > 80 ? "#37b4c5" : completenessPercentage > 50 ? "#a68b00" : "#c23a3a";

  return createPortal(
    <>
      <div className='sl-check-stock-overlay' onClick={() => closeModal(false)}>
        <div className='sl-check-stock-panel' onClick={(e) => e.stopPropagation()}>
          {isLoading ? (
            <div className='sl-check-stock-loading'>
              <Spinner position={""} transparent={false} backgroundColor={"white"} />
              <p>{loadingProgress}</p>
            </div>
          ) : (
            <>
              <div className='sl-check-stock-header'>
                <div className='sl-check-stock-header-title'>
                  <ClipboardList size={18} />
                  <div>
                    <h3>Stock Checking Window</h3>
                    <p>
                      <Calendar size={12} />
                      It is recommended to check your stock weekly
                    </p>
                  </div>
                </div>
                <button className='sl-check-stock-close-btn' onClick={() => closeModal(false)}>
                  <X size={18} />
                </button>
              </div>

              {showSummary && (
                <div className='sl-check-stock-summary'>
                  <div className='sl-check-stock-gauge'>
                    <CompletenssChart value={parseInt(completenessPercentage)} color={gaugeColor} />
                    <span className='sl-check-stock-gauge-label'>Completeness</span>
                  </div>
                  {["complete", "excess", "short", "pending"].map((key) => {
                    const c = productSummary.filter((s) => s.status === key).length;
                    return (
                      <div className='sl-check-stock-summary-stat' key={key}>
                        <span className='sl-check-stock-summary-value' style={{ color: STATUS_META[key].color }}>
                          {c}
                        </span>
                        <span className='sl-check-stock-summary-label'>{STATUS_META[key].label}</span>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className='sl-check-stock-toolbar'>
                <div className='sl-check-stock-search'>
                  <Search size={14} />
                  <input type='text' placeholder='Search products...' value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
                {showSummary && (
                  <div className='sl-check-stock-filter-chips'>
                    {["all", "complete", "excess", "short", "pending"].map((key) => (
                      <button
                        key={key}
                        className={"sl-check-stock-filter-chip" + (reportFilter === key ? " sl-check-stock-filter-chip--active" : "")}
                        style={
                          reportFilter === key && key !== "all"
                            ? { borderColor: STATUS_META[key].color, background: STATUS_META[key].tint, color: STATUS_META[key].color }
                            : undefined
                        }
                        onClick={() => setReportFilter(key)}
                      >
                        {key === "all" ? "All" : STATUS_META[key].label}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div className='sl-check-stock-list'>
                {!showSummary
                  ? visibleProducts.map((product) => {
                      const entry = productQtyInStore.find((p) => p.productID === product._id);
                      return (
                        <div className='sl-check-stock-row' key={product._id}>
                          <div className='sl-check-stock-row-main'>
                            <p className='sl-check-stock-row-name'>{product.name}</p>
                          </div>
                          <div className='sl-check-stock-row-input'>
                            <input
                              type='text'
                              inputMode='numeric'
                              placeholder='Qty'
                              value={entry?.qty ?? ""}
                              onChange={(e) => handleQtyChange(product._id, e.target.value)}
                            />
                            <span>{product.unit || "units"}</span>
                          </div>
                        </div>
                      );
                    })
                  : visibleSummary.map(({ product, counted, expected, diff, status }) => {
                      const meta = STATUS_META[status];
                      return (
                        <div
                          key={product._id}
                          className='sl-check-stock-row sl-check-stock-row--report'
                          onClick={() => {
                            setProductToShowHistory(product);
                            setShowProductHistory(true);
                          }}
                        >
                          <div className='sl-check-stock-row-icon' style={{ background: meta.tint, color: meta.color }}>
                            {meta.icon(16)}
                          </div>
                          <div className='sl-check-stock-row-main'>
                            <p className='sl-check-stock-row-name'>{product.name}</p>
                          </div>
                          <div className='sl-check-stock-row-figures'>
                            <div className='sl-check-stock-figure'>
                              <span className='sl-check-stock-figure-label'>Expected</span>
                              <span className='sl-check-stock-figure-value'>{expected.toLocaleString()}</span>
                            </div>
                            <div className='sl-check-stock-figure'>
                              <span className='sl-check-stock-figure-label'>Counted</span>
                              <span className='sl-check-stock-figure-value'>{counted !== null ? counted.toLocaleString() : "—"}</span>
                            </div>
                            <div className='sl-check-stock-figure'>
                              <span className='sl-check-stock-figure-label'>Diff</span>
                              <span className='sl-check-stock-figure-value' style={{ color: diff !== null && diff !== 0 ? meta.color : undefined }}>
                                {diff === null ? "—" : diff > 0 ? `+${diff}` : diff}
                              </span>
                            </div>
                          </div>
                          <span className='sl-check-stock-badge' style={{ color: meta.color, background: meta.tint }}>
                            {meta.label}
                          </span>
                          <ChevronRight size={16} className='sl-check-stock-row-chevron' />
                        </div>
                      );
                    })}

                {!isLoading && products.length === 0 && (
                  <div className='sl-check-stock-empty'>
                    <img src='https://res.cloudinary.com/ebuka1122/image/upload/v1712951361/Ihub-text-images/NoPath_jqqz1c.png' alt='' />
                    <p>No products found for this store.</p>
                  </div>
                )}
              </div>

              <div className='sl-check-stock-footer'>
                {!showSummary ? (
                  <>
                    <span className='sl-check-stock-footer-hint'>
                      {productQtyInStore.filter((p) => p.qty !== null && p.qty !== "").length} of {products.length} counted
                    </span>
                    <button className='sl-check-stock-run-btn' onClick={checkStock} disabled={!canRunCheck}>
                      Check
                    </button>
                  </>
                ) : (
                  <button className='sl-check-stock-recount-btn' onClick={() => setShowSummary(false)}>
                    <RotateCcw size={14} />
                    Recount
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {showProductHistory && (
        <ProductHistory
          closeModal={setShowProductHistory}
          storeID={store._id}
          product={productToShowHistory}
          setProductToShowHistory={setProductToShowHistory}
        />
      )}
    </>,
    document.body
  );
};

export default CheckStock;

const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

// single source of truth for icon + color per event type,
// shared by the timeline entries and the filter chips
const HISTORY_META = {
  created: { label: "Created", icon: () => <PlusCircle size={16} />, color: "#2f9e52", tint: "#eafaec" },
  modified: { label: "Modified", icon: () => <Pencil size={16} />, color: "#5b6ee1", tint: "#f0f3ff" },
  discountApplied: { label: "Discount Applied", icon: () => <Percent size={16} />, color: "#a68b00", tint: "#fbf7dc" },
  sold: { label: "Sold", icon: () => <ShoppingCart size={16} />, color: "#1f9d55", tint: "#edfcf0" },
  returned: { label: "Returned", icon: () => <Undo2 size={16} />, color: "#6b7280", tint: "#f2f2f2" },
  deleted: { label: "Deleted", icon: () => <Trash2 size={16} />, color: "#c23a3a", tint: "#ffe8e6" },
  restocked: { label: "Restocked", icon: () => <PackagePlus size={16} />, color: "#1698a8", tint: "#e7fafb" },
  damageReported: { label: "Damage Reported", icon: () => <AlertTriangle size={16} />, color: "#d1651f", tint: "#ffe9de" },
  moved: { label: "Moved", icon: () => <ArrowRightLeft size={16} />, color: "#2563eb", tint: "#eff6ff" },
};

const FILTER_ORDER = ["created", "modified", "discountApplied", "sold", "returned", "deleted", "restocked", "damageReported", "moved"];

function humanizeType(type) {
  const spaced = type.replace(/([A-Z])/g, " $1").trim();
  const lower = spaced.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export const ProductHistory = ({
  closeModal,
  storeID,
  product,
  setProductToShowHistory = () => {
    return null;
  },
}) => {
  const [monthInView, setMonthInView] = useState(months[new Date().getMonth()]);
  const [yearInView, setYearInView] = useState(new Date().getFullYear());
  const [showAllTime, setShowAllTime] = useState(false);
  const [showAllTimeUI, setShowAllTimeUI] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [history, setHistory] = useState([]);
  const [historyCopy, setHistoryCopy] = useState([]);
  const [rawHistoryData, setRawHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("All");
  const [isFilterSheetOpen, setIsFilterSheetOpen] = useState(false);
  const [quantityInFocus, setQuantityInFocus] = useState(0);
  const [displayText, setDisplayText] = useState(`${monthInView} ${yearInView}`);
  const { count, queue } = useSelector((state) => state.offlineQueue);

  useLayoutEffect(() => {
    checkOfflineQueueAndSync();
  }, []);

  useEffect(() => {
    if (showAllTime) {
      fetchProductHistory();
      setFilter("All");
    }
    setShowAllTime(false);
    setDisplayText("All Time History");
  }, [showAllTime, page, limit]);

  useEffect(() => {
    setShowAllTime(false);
    setFilter("All");
    setDisplayText(`${monthInView} ${yearInView}`);
  }, [yearInView, monthInView]);

  useEffect(() => {
    if (!showAllTime) {
      fetchProductHistory();
    }
  }, [storeID, product, yearInView, monthInView]);

  useEffect(() => {
    if (filter === "All") {
      let historyCopy = groupHistoryDataByDate(rawHistoryData);
      setHistory(historyCopy);
      return;
    }

    const filteredHistory = rawHistoryData?.filter((entry) => entry.historyType === filter);
    let quantityInFocus = filteredHistory.reduce((acc, entry) => {
      if (entry.historyType !== "discountApplied" && entry.historyType !== "modified") {
        return acc + entry.quantityInFocus;
      }
      return acc;
    }, 0);

    setQuantityInFocus(quantityInFocus);

    const groupedFilteredHistory = groupHistoryDataByDate(filteredHistory);
    setHistory(groupedFilteredHistory);
  }, [filter]);

  function buildQuery() {
    const params = new URLSearchParams();
    if (showAllTime) params.set("allTime", "true");
    if (!showAllTime && yearInView) params.set("year", yearInView);
    if (!showAllTime && monthInView) params.set("month", months.indexOf(monthInView));
    if (showAllTime) {
      params.set("page", page);
      params.set("limit", limit);
    }
    return params.toString();
  }

  const fetchProductHistory = async () => {
    setLoading(true);
    setError(null);
    const query = buildQuery();

    try {
      let response = await fetch(`${getProductHistoryUrl}${storeID}/${product._id}/?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const { data, pagination } = await response.json();
      setRawHistoryData(data);
      let groupData = groupHistoryDataByDate(data);
      setHistory(groupData);
      setHistoryCopy(groupData);
      if (pagination) {
        setTotalPages(pagination?.totalPages || 1);
        setPage(pagination?.page);
        setLimit(pagination.limit);
      }
    } catch (error) {
      console.error("Error fetching product history:", error);
      setError(`Failed to fetch product history: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const checkOfflineQueueAndSync = async () => {
    if (count) {
      try {
        await syncOfflineQueue();
      } catch (error) {
        setError(`Failed to synchronize offline queue: ${error.message}`);
        console.log(error);
      }
    }
  };

  const hasHistory = Object.keys(history).length > 0;

  // per-type counts + quantities, driving the filter chip badges
  const filterStats = useMemo(() => {
    const stats = {};
    FILTER_ORDER.forEach((type) => {
      stats[type] = { count: 0, quantity: 0 };
    });
    rawHistoryData.forEach((entry) => {
      if (!stats[entry.historyType]) return;
      stats[entry.historyType].count += 1;
      if (entry.historyType !== "discountApplied" && entry.historyType !== "modified") {
        stats[entry.historyType].quantity += entry.quantityInFocus;
      }
    });
    return stats;
  }, [rawHistoryData]);

  const handleExport = () => {
    if (!hasHistory) return;

    const rows = Object.entries(history).flatMap(([dateLabel, entries]) =>
      entries.map((entry) => ({
        Date: dateLabel,
        Time: new Date(entry.historyDate).toLocaleTimeString(),
        Event: humanizeType(entry.historyType),
        Description: entry.historyText,
        Quantity: entry.quantityInFocus,
      }))
    );

    const worksheet = XLSX.utils.json_to_sheet(rows);
    worksheet["!cols"] = [{ wch: 16 }, { wch: 12 }, { wch: 16 }, { wch: 44 }, { wch: 10 }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "History");

    const safeName = (product?.name || "product").replace(/[^a-z0-9]+/gi, "-");
    XLSX.writeFile(workbook, `${safeName}-history-${displayText}.xlsx`);
  };

  const renderFilterPanelBody = (onPick) => (
    <>
      <button
        onClick={() => {
          setFilter("All");
          onPick && onPick();
        }}
        className={"sl-prod-hist-all-chip" + (filter === "All" ? " sl-prod-hist-all-chip--active" : "")}
      >
        <span>All events</span>
        <span className='sl-prod-hist-all-chip-count'>{rawHistoryData.length}</span>
      </button>

      <div className='sl-prod-hist-chip-grid'>
        {FILTER_ORDER.map((type) => {
          const meta = HISTORY_META[type];
          const stats = filterStats[type];
          const isActive = filter === type;
          return (
            <button
              key={type}
              onClick={() => {
                setFilter(type);
                onPick && onPick();
              }}
              className={"sl-prod-hist-chip" + (isActive ? " sl-prod-hist-chip--active" : "")}
              style={isActive ? { borderColor: meta.color, background: meta.tint } : undefined}
            >
              <span className='sl-prod-hist-chip-icon' style={{ background: meta.tint, color: meta.color }}>
                {meta.icon()}
              </span>
              <span className='sl-prod-hist-chip-text'>
                <span className='sl-prod-hist-chip-label'>{meta.label}</span>
                <span className='sl-prod-hist-chip-count'>
                  {stats.count} event{stats.count === 1 ? "" : "s"}
                </span>
              </span>
              {isActive && (
                <span className='sl-prod-hist-chip-check' style={{ background: meta.color }}>
                  <Check size={11} color='#fff' strokeWidth={3} />
                </span>
              )}
            </button>
          );
        })}
      </div>

      {filter !== "All" && filter !== "discountApplied" && filter !== "modified" && (
        <div className='sl-prod-hist-quantity-card' style={{ borderColor: HISTORY_META[filter]?.color }}>
          <h4>Quantity &middot; {HISTORY_META[filter]?.label}</h4>
          <div className='sl-prod-hist-quantity-value' style={{ color: HISTORY_META[filter]?.color }}>
            {quantityInFocus.toLocaleString()}
          </div>
        </div>
      )}
    </>
  );

  const mainOverlay = (
    <div
      className='sl-prod-hist-overlay'
      onClick={() => {
        closeModal(false);
        setProductToShowHistory(null);
      }}
    >
      <div className='sl-prod-hist-panel' onClick={(e) => e.stopPropagation()}>
        <div className='sl-prod-hist-header'>
          <div>
            <h3 className='sl-prod-hist-title'>
              Product history for <span className='sl-prod-hist-title-name'>{product.name}</span>
            </h3>
            <p className='sl-prod-hist-subtitle'>
              {displayText} &middot; {rawHistoryData.length} event{rawHistoryData.length === 1 ? "" : "s"}
            </p>
          </div>
          <div className='sl-prod-hist-header-actions'>
            <button className='sl-prod-hist-export-btn' onClick={handleExport} disabled={!hasHistory} title='Export this view as an Excel file'>
              <Download size={15} />
              <span>Export</span>
            </button>
            <button
              className='sl-prod-hist-close-btn'
              onClick={() => {
                closeModal(false);
                setProductToShowHistory(null);
              }}
            >
              <AiOutlineClose size={18} />
            </button>
          </div>
        </div>

        <div className='sl-prod-hist-body'>
          <div className='sl-prod-hist-main'>
            <div className='sl-prod-hist-filters-row'>
              <button
                className={"sl-prod-hist-alltime-btn" + (showAllTimeUI ? " sl-prod-hist-alltime-btn--active" : "")}
                onClick={() => {
                  setShowAllTime(true);
                  setShowAllTimeUI(true);
                }}
              >
                <Calendar size={14} />
                {showAllTime || showAllTimeUI ? "All time history" : "Show all time"}
              </button>
              <DropdownFilter
                onYearChange={(y) => {
                  setYearInView(y);
                  setShowAllTimeUI(false);
                }}
                onMonthChange={(m) => {
                  setMonthInView(m);
                  setShowAllTimeUI(false);
                }}
                defaultYear={yearInView}
                defaultMonth={monthInView}
              />
              <button className='sl-prod-hist-filter-trigger' onClick={() => setIsFilterSheetOpen(true)}>
                <SlidersHorizontal size={14} />
                {filter === "All" ? "All events" : HISTORY_META[filter]?.label}
              </button>
            </div>

            <div className='sl-prod-hist-list'>
              {loading ? (
                <div className='sl-prod-hist-loading'>
                  <ActivityLogSkeleton />
                </div>
              ) : hasHistory ? (
                Object.entries(history).map(([dateLabel, entries]) => (
                  <div key={dateLabel} className='sl-prod-hist-group'>
                    <h5 className='sl-prod-hist-group-label'>{dateLabel}</h5>
                    <div className='sl-prod-hist-timeline'>
                      {entries
                        .slice()
                        .reverse()
                        .map((entry, i, arr) => (
                          <EachProductHistory key={entry._id} productHistory={entry} isLast={i === arr.length - 1} />
                        ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className='sl-prod-hist-empty'>
                  <img src='https://res.cloudinary.com/ebuka1122/image/upload/v1750534402/Ihub/noHistoryFound_numkw3.webp' alt='' />
                  <p>No history found for selected timeline</p>
                </div>
              )}
            </div>

            {displayText === "All Time History" && (
              <Pagination page={page} totalPages={totalPages} onPageChange={setPage} limit={limit} onLimitChange={setLimit} />
            )}
          </div>

          <div className='sl-prod-hist-filter-panel sl-prod-hist-filter-panel--desktop'>
            <h4 className='sl-prod-hist-filter-title'>Filter by event</h4>
            {renderFilterPanelBody()}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {createPortal(mainOverlay, document.body)}
      {isFilterSheetOpen &&
        createPortal(
          <div className='sl-prod-hist-sheet-overlay' onClick={() => setIsFilterSheetOpen(false)}>
            <div className='sl-prod-hist-sheet' onClick={(e) => e.stopPropagation()}>
              <div className='sl-prod-hist-sheet-handle' />
              <div className='sl-prod-hist-sheet-header'>
                <h4>Filter by event</h4>
                <button className='sl-prod-hist-sheet-close' onClick={() => setIsFilterSheetOpen(false)}>
                  <AiOutlineClose size={16} />
                </button>
              </div>
              <div className='sl-prod-hist-sheet-body'>{renderFilterPanelBody(() => setIsFilterSheetOpen(false))}</div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

const EachProductHistory = ({ productHistory, isLast }) => {
  const meta = HISTORY_META[productHistory.historyType] || HISTORY_META.moved;

  return (
    <div className='sl-prod-hist-entry'>
      <div className='sl-prod-hist-entry-rail'>
        <div className='sl-prod-hist-entry-icon' style={{ background: meta.tint, color: meta.color }}>
          {meta.icon()}
        </div>
        {!isLast && <span className='sl-prod-hist-entry-line' />}
      </div>
      <div className='sl-prod-hist-entry-body'>
        <div className='sl-prod-hist-entry-top'>
          <p className='sl-prod-hist-entry-text'>{productHistory.historyText}</p>
          <div className='sl-prod-hist-entry-qty'>{productHistory.quantityInFocus.toLocaleString()}</div>
        </div>
        <span className='sl-prod-hist-entry-badge' style={{ color: meta.color, background: meta.tint }}>
          {meta.label}
        </span>
      </div>
    </div>
  );
};

const groupHistoryDataByDate = (historyData) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const historyDataGroups = historyData.reduce((acc, entry) => {
    const dateObj = new Date(entry.historyDate);
    const entryDate = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());

    let dateLabel;
    if (entryDate.getTime() === today.getTime()) {
      dateLabel = "Today";
    } else if (entryDate.getTime() === yesterday.getTime()) {
      dateLabel = "Yesterday";
    } else {
      dateLabel = dateObj.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    if (!acc[dateLabel]) acc[dateLabel] = [];
    acc[dateLabel].push(entry);
    return acc;
  }, {});

  return historyDataGroups;
};
